import { FormattedMessage } from "react-intl";

export const EmailInvalidFormatText = () => {
  return <FormattedMessage id="lang-email-invalid-format" />;
};

export const EmailRequiredText = () => {
  return <FormattedMessage id="lang-email-required" />;
};

export const FirstNameRequiredText = () => {
  return <FormattedMessage id="lang-first-name-required" />;
};

export const LastNameRequiredText = () => {
  return <FormattedMessage id="lang-last-name-required" />;
};

export const PasswordRequiredText = () => {
  return <FormattedMessage id="lang-password-required" />;
};

export const PasswordMinLengthText = () => {
  return <FormattedMessage id="lang-password-min-length" />;
};

export const PasswordMaxLengthText = () => {
  return <FormattedMessage id="lang-password-max-length" />;
};

export const OldPasswordRequiredText = () => {
  return <FormattedMessage id="lang-old-password-required" />;
};

export const PasswordNoMatchText = () => {
  return <FormattedMessage id="lang-password-no-match" />;
};

export const PhoneRequiredText = () => {
  return <FormattedMessage id="lang-phone-required" />;
};

export const PhoneInvalidFormatText = () => {
  return <FormattedMessage id="lang-phone-invalid-format" />;
};

export const RecaptchaRequriedText = () => {
  return <FormattedMessage id="lang-recaptcha-required" />;
};

export const DateofBirthRequriedText = () => {
  return <FormattedMessage id="lang-date-of-birth-required" />;
};

export const DateofBirthInvalidFormatText = () => {
  return <FormattedMessage id="lang-date-of-birth-invalid-format" />;
};

export const DateofBirthNineteenInvalidFormatText = () => {
  return <FormattedMessage id="lang-date-of-birth-nineteen-invalid-format" />;
};

export const DateofAnniversaryInvalidFormatText = () => {
  return <FormattedMessage id="lang-date-of-anniversary-invalid-format" />;
};

export const VerificationCodeRequiredText = () => {
  return <FormattedMessage id="lang-verification-code-required" />;
};

export const VerificationCodeInvalidFormat = () => {
  return <FormattedMessage id="lang-verification-code-invalid-format" />;
};

export const TypeRequiredText = () => {
  return <FormattedMessage id="lang-type-required" />;
};

export const AddressRequiredText = () => {
  return <FormattedMessage id="lang-address-required" />;
};

export const CountryRequiredText = () => {
  return <FormattedMessage id="lang-country-required" />;
};

export const StateRequiredText = () => {
  return <FormattedMessage id="lang-state-required" />;
};

export const CityRequiredText = () => {
  return <FormattedMessage id="lang-city-required" />;
};

export const PostalCodeRequiredText = () => {
  return <FormattedMessage id="lang-postal-code-required" />;
};

export const PrivacyPolicyRequiredText = () => {
  return <FormattedMessage id="lang-privacy-policy-required" />;
};

export const DateRequiredText = () => {
  return <FormattedMessage id="lang-date-required" />;
};

// Label Texts

export const FirstNameLabelText = () => {
  return <FormattedMessage id="lang-first-name-label" />;
};

export const LastNameLabelText = () => {
  return <FormattedMessage id="lang-last-name-label" />;
};

export const EmailLabelText = () => {
  return <FormattedMessage id="lang-email-label" />;
};

export const PhoneLabelText = () => {
  return <FormattedMessage id="lang-phone-label" />;
};

export const DateofBirthLabelText = () => {
  return <FormattedMessage id="lang-date-of-birth-label" />;
};

export const PrivacyPolicyLabelText = () => {
  return <FormattedMessage id="lang-privacy-policy-label" />;
};

export const MailOptLabelText = () => {
  return <FormattedMessage id="lang-mail-opt-label" />;
};

export const MailOptContentText = () => {
  return (
    <FormattedMessage
      id="lang-mail-opt-content"
      values={{
        linebreak: <br />,
      }}
    />
  );
};

export const MailUseLabelText = () => {
  return <FormattedMessage id="lang-mail-use-label" />;
};

export const MailUseContentText = () => {
  return (
    <FormattedMessage
      id="lang-mail-use-content"
      values={{
        linebreak: <br />,
      }}
    />
  );
};

export const ConfirmPasswordLabelText = () => {
  return <FormattedMessage id="lang-confirm-password-label" />;
};

export const NewPasswordLabelText = () => {
  return <FormattedMessage id="lang-new-password-label" />;
};

export const OldPasswordLabelText = () => {
  return <FormattedMessage id="lang-old-password-label" />;
};

export const EmailExistErrorText = () => {
  return <FormattedMessage id="lang-email-exist-error" />;
};

export const LegalAgeRequiredText = () => {
  // Please confirm that you are legal age
  return <FormattedMessage id="lang-legal-age-required" />;
};

export const PasswordResetSuccessText = () => {
  // Your Password reset successfully
  return <FormattedMessage id="lang-password-reset-successfully" />;
};

export const SelectOneText = () => {
  return <FormattedMessage id="lang-select-one" />;
};

export const YesText = () => {
  return <FormattedMessage id="lang-yes" />;
};

export const NoText = () => {
  return <FormattedMessage id="lang-no" />;
};
